var map = {
	"./arrow.svg": 2651,
	"./book.svg": 4389,
	"./brain.svg": 7476,
	"./btnBorder.svg": 1963,
	"./cards.svg": 2068,
	"./flower.svg": 2789,
	"./guap_logo.svg": 9702,
	"./heart.svg": 6321,
	"./logo.svg": 3925,
	"./measuring.svg": 1508,
	"./mind.svg": 9591,
	"./ok.svg": 3219,
	"./paraweb-logo.svg": 3437,
	"./rays.svg": 2556,
	"./star.svg": 8891,
	"./star/1.svg": 2419,
	"./star/2.svg": 383,
	"./star/3.svg": 6707,
	"./star/4.svg": 6875,
	"./star/5.svg": 1520,
	"./starBorder.svg": 1949,
	"./tg.svg": 5446,
	"./vk.svg": 4209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;